
<div>
    <!-- <pre-registration-welcome></pre-registration-welcome> -->
 <router-outlet></router-outlet>
</div>
